import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ProductComponent } from '../../../components/product/product.component';
import { ProductService } from './product.service';
import { rxResource } from '@angular/core/rxjs-interop';
import { Variant } from './product.types';
import { HeaderComponent } from '../../../components/header/header.component';
import { FooterComponent } from '../../../components/footer/footer.component';
import { MiniCartComponent } from '../../../components/mini-cart/mini-cart.component';
import { ProductSkeletonComponent } from '../../../components/product/product-skeleton/product-skeleton.component';
import { NotFoundContentComponent } from '../../../components/not-found-content/not-found-content.component';

@Component({
  selector: 'app-product-page',
  imports: [
    ProductComponent,
    HeaderComponent,
    FooterComponent,
    ProductSkeletonComponent,
    NotFoundContentComponent,
    MiniCartComponent,
  ],
  templateUrl: './product-page.component.html',
  styleUrls: ['./product-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProductService],
})
export class ProductPageComponent {
  productService = inject(ProductService);
  product = {} as Variant;

  variantRes = rxResource({
    loader: () => this.productService.getProduct(),
  });
}
